import config from '@/config/user.env';
import { BigDataLog } from './bigDataLog';

const bigDataLog = new BigDataLog({
    appSecrect: config.bigDataLogAppSecrect,
    appName: config.bigDataLogAppName,
    baseUrl: config.bigDataLogUrl,
    tokenUrl: config.bigDataLogTokenUrl
});

export function useBigDataLog() {
    return bigDataLog;
}

/// 路由切换时的大数据监控
export function bigDataLogOnRouteSwitch(route) {
    const bigDataLog = useBigDataLog();
    const names = bigDataLog.routeToNames(route);
    if (names.length) {
        bigDataLog.sendDetailMessage({
            model_name1: names[0],
            model_name2: names[1],
            model_name3: names[2],
            model_name4: names[3]
        });
    }
}
